<template>
    <div class="content-footer" :style="propStyle">
        <div class="content-footer-left">
            <img :src="ylvsImg">
            <span>
                {{ localesPackage?.['badgewall_sharepage_footer1']?.[localesEnv] }} <br/>
                {{ localesPackage?.['badgewall_sharepage_footer2']?.[localesEnv] }}
            </span>
        </div>
        <div class="content-footer-right">
            <img :src="ylvsCodeImg">
        </div>
    </div>
</template>

<script>
import { onBeforeMount, onMounted, ref, computed, nextTick } from "vue";
import _ from "lodash";
import { mapState } from "vuex";
import ylvsCode from "@/assets/images/YuliApp/badgeWall/share/2base64/ylvs_code.js";
import ylvs from "@/assets/images/YuliApp/badgeWall/share/2base64/ylvs.js";
export default {
components: {},
props: {
    propStyle: {
        type: Object,
        default: ()=>{
            return {}
        },
    },
},
computed: {
    ...mapState({
        languageEnv: (state) => state.global.languageEnv,
        languagePackage: (state) => state.global.languagePackage,
    }),
},
watch: {
    languageEnv: {
        async handler(value) {
            if(value){
                this.localesEnv = value;
            }
        },
        immediate: true,
        deep: true,
    },
    languagePackage: {
        async handler(value) {
            if(value){
                this.localesPackage = value;
            }
        },
        immediate: true,
        deep: true,
    },
},
setup(props, { emit }) {
    // const {  } = props;
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref('en');
    const ylvsImg = ref(null);
    const ylvsCodeImg = ref(null);

    onMounted(()=>{
        ylvsImg.value = ylvs;
        ylvsCodeImg.value = ylvsCode;
    })

    const toParentHandle = (type) => {
        emit('handle', type);
    }

    return {
        toParentHandle,
        localesPackage,
        localesEnv,
        ylvsImg,
        ylvsCodeImg
    };
},
};
</script>
  
<style lang="less" scoped>
    .content-footer{
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        &-left{
            display: flex;
            flex-direction: column;
            justify-content: center;
            img{
                width: 152px;
                height: 36px;
            }
            span{
                text-align: left;
                width: 170px;
                color: #000000;
                font-family: "PingFang SC";
                font-size: 11px;
                font-weight: 300;
                line-height: 12.54px;
            }
        }
        &-right{
            display: flex;
            align-items: center;
            justify-content: center;
            img{
                width: 66px;
                height: 66px;
            }
        }
    }
</style>
  